// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_0Ph","cls2":"News-cls2_JUT News-cls1_0Ph"};